import { render, staticRenderFns } from "./whatsNew.vue?vue&type=template&id=75949a2a&scoped=true&"
import script from "./whatsNew.vue?vue&type=script&lang=js&"
export * from "./whatsNew.vue?vue&type=script&lang=js&"
import style0 from "./whatsNew.vue?vue&type=style&index=0&id=75949a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75949a2a",
  null
  
)

export default component.exports